module.exports = __webpack_public_path__ + "static/media/logo.a45ecbe7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/general/logo.svg
// module id = 251
// module chunks = 6